export default {
  GET_HEALTH_ADX_REQUESTED: 'GET_HEALTH_ADX_REQUESTED',
  GET_HEALTH_ADX_SUCCEEDED: 'GET_HEALTH_ADX_SUCCEEDED',
  GET_HEALTH_ADX_FAILED: 'GET_HEALTH_ADX_FAILED',

  GET_HEALTH_NETWORK_REQUESTED: 'GET_HEALTH_NETWORK_REQUESTED',
  GET_HEALTH_NETWORK_SUCCEEDED: 'GET_HEALTH_NETWORK_SUCCEEDED',
  GET_HEALTH_NETWORK_FAILED: 'GET_HEALTH_NETWORK_FAILED',

  GET_YIELD_PARTNER_REQUESTED: 'GET_YIELD_PARTNER_REQUESTED',
  GET_YIELD_PARTNER_SUCCEEDED: 'GET_YIELD_PARTNER_SUCCEEDED',
  GET_YIELD_PARTNER_FAILED: 'GET_YIELD_PARTNER_FAILED',

  GET_PROGRAMMATIC_REQUESTED: 'GET_PROGRAMMATIC_REQUESTED',
  GET_PROGRAMMATIC_SUCCEEDED: 'GET_PROGRAMMATIC_SUCCEEDED',
  GET_PROGRAMMATIC_FAILED: 'GET_PROGRAMMATIC_FAILED',

  GET_PUBLISHER_REQUESTED: 'GET_PUBLISHER_REQUESTED',
  GET_PUBLISHER_SUCCEEDED: 'GET_PUBLISHER_SUCCEEDED',
  GET_PUBLISHER_FAILED: 'GET_PUBLISHER_FAILED',

  SHOW_PROGRAMMATIC_VIEW: 'SHOW_PROGRAMMATIC_VIEW',
}
